
export const paymentMethod = {
    selectPaymentMethod: '选择支付方式',
    orderSummary: '订单摘要',
    choosePaymentMethod: '选择您偏好的支付方式',
    creditCard: '信用卡/借记卡',
    creditCardDescription: '通过 Stripe 安全地使用您的信用卡或借记卡支付',
    paypalDescription: '使用您的 PayPal 帐户或 PayPal 余额支付',
    securityNote: '您的支付信息已加密并且安全',
    processing: '正在处理支付...',
    paymentFailed: '支付失败，请重试。',
    paymentCancelled: '支付已取消。',
    invalidPaymentMethod: '选择的支付方式无效。',
    networkError: '网络错误，请检查您的连接并重试。',
    paypalPayment: 'PayPal 支付',
    loadingPayPal: '正在加载 PayPal...',
    paypalSecurityNote: '您的支付由 PayPal 安全处理'
  };
